const { VARIANTS } = require('../../../server/types/variants');

const inExperiment = (experimentId, abTests = {}, variants = [VARIANTS.B]) => {
    const variation = getVariation(experimentId, abTests);

    return variants.includes(variation);
};

const getVariation = (experimentId, abTests = {}) => {
    const variation = abTests[experimentId];

    return transformVariation(variation);
};

const isAllocated = (experimentId, abTests = {}) => {
    const variation = Number(abTests[experimentId]);

    return variation >= VARIANTS.A;
};

const transformVariation = (variation) => {
    switch (Number(variation)) {
        case 1:
            return VARIANTS.A;
        case 2:
            return VARIANTS.B;
        case 3:
            return VARIANTS.C;
        default:
            return VARIANTS.A;
    }
};

module.exports = {
    inExperiment,
    getVariation,
    isAllocated
};
